import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import TextInput from './text-input'
import TextArea from './text-area'

function FormModal({template, onClose, onCreate, onUpdate}) {
  const isNew = !template.id
  const [title, setTitle] = useState(template.title || '')
  const [text, setText] = useState(template.text || '')
  const [titleError, setTitleError] = useState(null)
  const [textError, setTextError] = useState(null)
  const presenceError = "Can't be blank"

  const onSubmit = (e) => {
    e.preventDefault()

    const [validTitle, validText] = [!_.isEmpty(title.trim()), !_.isEmpty(text.trim())]
    validTitle ? setTitleError(null) : setTitleError(presenceError)
    validText ? setTextError(null) : setTextError(presenceError)

    if (!validTitle || !validText) return
    
    if (isNew) 
      onCreate({ title: title, text: text })
    else 
      onUpdate({ id: template.id, title: title, text: text })
  }

  return (
    <Modal container={document.body} id='template-modal' isOpen={true} onRequestClose={onClose}>
      <div id='template-form'>
        <h3>{isNew ? 'Create new template' : 'Edit template'}</h3>
        <form className='form-horizontal' onSubmit={onSubmit}>
          <TextInput
            value={title}
            placeholder='Title'
            onChange={(e) => setTitle(e.target.value)}
            error={titleError}
          />
          <TextArea
            value={text}
            placeholder='Text'
            onChange={(e) => setText(e.target.value)}
            error={textError}
          />
          <input type='submit' value='Save Template' className='btn btn-success' />
        </form>
      </div>
    </Modal>
  )
}

FormModal.propTypes = {
  template: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
}

export default FormModal

